import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import { Download, Printer } from 'lucide-react';

const ViewAgreementModal = ({ isOpen, onClose, agreement }) => {
  const handlePrint = () => {
    window.print();
  };

  const handleDownload = () => {
    // Create a printable version
    const printWindow = window.open('', '', 'height=800,width=800');
    printWindow.document.write('<html><head><title>Rent Agreement</title>');
    printWindow.document.write('<style>body{font-family:Arial,sans-serif;padding:40px;line-height:1.6;}h1{text-align:center;text-decoration:underline;}p{margin:10px 0;text-align:justify;}</style>');
    printWindow.document.write('</head><body>');
    printWindow.document.write(document.getElementById('agreement-content').innerHTML);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    printWindow.print();
  };

  function getDaySuffix(day) {
    if (day > 3 && day < 21) return 'th';
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  }

  function formatDate(dateStr) {
    const date = new Date(dateStr);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'long' });
    const year = date.getFullYear();
    return `${day}${getDaySuffix(day)} day of ${month} ${year}`;
  }

  const calculateMonths = (startDate, endDate) => {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const months = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth());
    return months;
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-5xl max-h-[90vh] overflow-y-auto" style={{backgroundColor: '#f5f5f0'}}>
        <DialogHeader>
          <DialogTitle className="flex items-center justify-between">
            <span>Rent Agreement - {agreement.lessee_name}</span>
            <div className="flex gap-2">
              <Button
                onClick={handleDownload}
                size="sm"
                variant="outline"
                className="border-blue-600 text-blue-600"
              >
                <Download size={16} className="mr-1" />
                Download
              </Button>
              <Button
                onClick={handlePrint}
                size="sm"
                variant="outline"
                className="border-green-600 text-green-600"
              >
                <Printer size={16} className="mr-1" />
                Print
              </Button>
            </div>
          </DialogTitle>
        </DialogHeader>

        <div id="agreement-content" className="space-y-4 p-8 bg-white" style={{fontFamily: 'Times New Roman, serif', fontSize: '14px', lineHeight: '1.8'}}>
          <h1 className="text-xl font-bold text-center underline mb-8" style={{letterSpacing: '2px'}}>RENT AGREEMENT</h1>

          <p className="text-justify mb-4">
            THIS RENT AGREEMENT is executed at <strong>Gurugram</strong> on this <strong>{formatDate(agreement.agreement_date)}</strong>
          </p>

          <p className="text-justify mb-4">
            <strong>BETWEEN</strong>
          </p>

          <p className="text-justify mb-4" style={{textIndent: '40px'}}>
            <strong>{agreement.lessor_name}</strong>, R/o {agreement.lessor_address} (Hereinafter called the <strong>Lessor</strong> which expression shall unless excluded by or repugnant to the context include his/her/their heirs, executioners, administrator and representatives and assign)
          </p>

          <p className="text-center my-6">
            <strong>AND</strong>
          </p>

          <p className="text-justify mb-4" style={{textIndent: '40px'}}>
            <strong>{agreement.lessee_name}</strong>
            {agreement.lessee_aadhar && `, Aadhar No.: ${agreement.lessee_aadhar}`}
            {agreement.lessee_address && `, C/o ${agreement.lessee_address}`}. (Hereinafter called the <strong>Lessee</strong> which expression shall unless repugnant to the context remaining thereof induce his/her/their/ successors and assigns) of the other part,
          </p>

          <p className="text-justify mb-6" style={{textIndent: '40px'}}>
            <strong>WHEREAS</strong> the Lessor is the lawful owner in Possession of <strong>{agreement.property_description}</strong> Situated at <strong>{agreement.property_address}, Room No. {agreement.room_number}</strong>. (hereinafter called the <strong>Property</strong>).
          </p>

          <p className="text-justify font-bold mb-6">
            NOW THIS DEED WITNESSETH AS FOLLOWS:-
          </p>

          <div className="space-y-4 mb-6">
            <p className="text-justify" style={{textIndent: '40px'}}>
              <strong>1.</strong> That the Lessor has given the possession of the Property to the Lessee on <strong>{agreement.lease_start_date}</strong> to <strong>{agreement.lease_end_date}</strong> (<strong>{calculateMonths(agreement.lease_start_date, agreement.lease_end_date)} Month</strong> lease). The lease can be extended or renewed with mutual consent of both parties with <strong>{agreement.rent_increase_percentage}%</strong> increase in rent.
            </p>

            <p className="text-justify" style={{textIndent: '40px'}}>
              <strong>2.</strong> That the Lessee shall pay the Lessor for the property <strong>Rs. {agreement.monthly_rent}/-</strong> per month in advance by cash/cheque/Online on or before <strong>{agreement.payment_due_day}th</strong> day of every English Calendar month.
            </p>

            <p className="text-justify" style={{textIndent: '40px'}}>
              <strong>3.</strong> That the Lessee has paid <strong>Rs. {agreement.security_deposit}/-</strong> as Security Deposit to be refunded without interest free at the time of termination of the lease or vacation of the Residential after deducting outstanding dues if any.
            </p>

            <p className="text-justify" style={{textIndent: '40px'}}>
              <strong>4.</strong> That the Lessee shall use the property exclusively for Residential purpose and shall not sublet the whole or part of the tenancy premises to any other person or permit any other person without written permission of the Lessor to occupy the tenancy premises.
            </p>

            <p className="text-justify" style={{textIndent: '40px'}}>
              <strong>5.</strong> That the Lessee shall pay for electricity charges according to the bills raised from the appropriate electricity authority.
            </p>

            <p className="text-justify" style={{textIndent: '40px'}}>
              <strong>6.</strong> That the First party can inspect at any time of the said rented premises.
            </p>

            <p className="text-justify" style={{textIndent: '40px'}}>
              <strong>7.</strong> That the tenancy may be renewed with mutual consent of both the parties after the expiration of the tenancy period.
            </p>

            <p className="text-justify" style={{textIndent: '40px'}}>
              <strong>8.</strong> That the Second party shall have no right to let out the whole or part of tenancy premises to any other person.
            </p>

            <p className="text-justify" style={{textIndent: '40px'}}>
              <strong>9.</strong> That the Lessee shall comply with all the rules and regulations of the local authorities regarding the property.
            </p>

            <p className="text-justify" style={{textIndent: '40px'}}>
              <strong>10.</strong> That the Lessee shall not carry out any structural additions or alterations to the building layout fittings and fixtures in the premises without the prior written consent of the Lessor.
            </p>

            <p className="text-justify" style={{textIndent: '40px'}}>
              <strong>11.</strong> That the Lessee at the time of occupation shall see that electrical, sanitary fittings and fixtures are intact and in perfect working order and the Lessee shall be responsible to restore them to the same condition except natural wear and tear and damages by act of nature at the time of vacation of the premises.
            </p>

            <p className="text-justify" style={{textIndent: '40px'}}>
              <strong>12.</strong> That at the expiry of the period of lease the Lessee shall handover the physical vacant possession to the Lessor with all the fittings and fixtures intact and in perfect working order except natural wear and tear.
            </p>

            <p className="text-justify" style={{textIndent: '40px'}}>
              <strong>13.</strong> That if the Lessee makes default in the payment of rent or commits any other breach of the agreement the Lessor is entitled to get back the possession of the property immediately according to law.
            </p>

            <p className="text-justify" style={{textIndent: '40px'}}>
              <strong>14.</strong> That the lease can be terminated by the Lessor and the Lessee by serving one month notice.
            </p>
          </div>

          <p className="text-justify font-bold my-8">
            IN WITNESS WHEREOF THE LESSOR AND LESSEE HAVE SET THEIR HANDS AT GURUGRAM ON THE DATE, MONTH AND YEAR HEREINABOVE MENTIONED THE PRESENCE OF THE WITNESSES GIVEN BELOW:-
          </p>

          <div className="mt-12" style={{pageBreakInside: 'avoid'}}>
            <div className="grid grid-cols-2 gap-16">
              <div>
                <p className="font-bold mb-6">WITNESSES:</p>
                <div className="space-y-8">
                  <div>
                    <p className="mb-2">1.</p>
                    <div className="border-b border-black w-full mb-1"></div>
                  </div>
                  <div>
                    <p className="mb-2">2.</p>
                    <div className="border-b border-black w-full mb-1"></div>
                  </div>
                </div>
              </div>

              <div className="space-y-12">
                <div className="text-right">
                  <div className="border-b border-black w-48 ml-auto mb-2"></div>
                  <p className="font-bold">LESSOR</p>
                  <p className="text-sm mt-1">({agreement.lessor_name})</p>
                </div>
                <div className="text-right">
                  <div className="border-b border-black w-48 ml-auto mb-2"></div>
                  <p className="font-bold">LESSEE</p>
                  <p className="text-sm mt-1">({agreement.lessee_name})</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="flex gap-4 pt-4">
          <Button onClick={onClose} variant="outline" className="flex-1">
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ViewAgreementModal;
